import { render, staticRenderFns } from "./delivero_general_tab.vue?vue&type=template&id=635b7a9a&scoped=true&"
import script from "./delivero_general_tab.vue?vue&type=script&lang=js&"
export * from "./delivero_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b7a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635b7a9a')) {
      api.createRecord('635b7a9a', component.options)
    } else {
      api.reload('635b7a9a', component.options)
    }
    module.hot.accept("./delivero_general_tab.vue?vue&type=template&id=635b7a9a&scoped=true&", function () {
      api.rerender('635b7a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/delivero/location/tabs/delivero_general_tab.vue"
export default component.exports